module.exports = __webpack_public_path__ + "static/media/survey.3e474e7d.svg";